/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit/react";

export type dataType = "Public" | "Private" | "Nasdaq" | "Company" | "vip" | "hr" | "marketing" | "none" | "unified" | 'employee';

type SearchState = {
  type: dataType | "all";
  searchTerm: string;
  data: any[] | [];
  totalHits: number;
  querySuccess?: boolean;
  limit: number;
  page: number;
  validDocs?: number;
  isFetching?: boolean;
  filters?: {
    area_of_interest?: string[];
    total_donation?: number;
  };
};
const initialState: SearchState = {
  type: "none",
  searchTerm: "",
  data: [],
  totalHits: 0,
  limit: 50,
  validDocs: 0,
  querySuccess: false,
  page: 1,
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setIsFetching: (state, action) => {
      state.isFetching = action.payload;
    },
    addData: (state, action) => {
      state.data = [...state.data, ...action.payload];
    },
    initData: (_, action: { payload: SearchState }) => {
      return action.payload;
    },
    appendData: (state, action: { payload: { source: any[]; totalHits: number; page: number; limit: number } }) => {
      state.data = [...state.data, ...action.payload.source];
      state.totalHits = action.payload.totalHits;
      state.page = action.payload.page;
      state.limit = action.payload.limit;
    },
    setTotalHits: (state, action) => {
      state.totalHits = action.payload;
    },
    setData: (state, action) => {
      state.data = action.payload;
      state.totalHits = action.payload.length || 0;
    },
    setType: (state, action: { payload: dataType }) => {
      state.type = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    clearData: () => {
      return initialState;
    },
    setQuerySuccess: (state, action) => {
      state.querySuccess = action.payload;
    },
  },
});
export const {
  setSearchTerm,
  setData,
  clearData,
  addData,
  appendData,
  setTotalHits,
  initData,
  setPage,
  setType,
  setIsFetching,
  setQuerySuccess,
} = searchSlice.actions;
